import { useMutation, useQuery } from '@tanstack/react-query';
import { request } from 'utils/request';

export const getListBanner = params => request.get('/api/v1/banners', { params });
export const setActiveBanner = data => request.post('/api/v1/banners/update-status', data);

export const createBanner = data => request.post('/api/v1/banners', data);
// export const updateCategory = data => request.post('/api/v1/categories/update', data);
export const updateBanner = data => request.post('/api/v1/banners/update', data);
export const deleteBanner = data => request.post('/api/v1/banners/delete', data);
export const deleteMutilShortlink = data => request.post('/api/v1/short-links/delete-multiple', data);
export const exportTemplate = (data) => request.post('/api/v1/categories/export-template', data, { responseType: 'arraybuffer' })
export const importFile = (data, config) =>
  request.post('/api/v1/short-links/import', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    ...config,
  });

export const updateThumbnail = async data => {
  return await request.post('/api/v1/common/upload-thumbnail', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const uploadBanner = async data => {
  return await request.post('/api/v1/banners/upload', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};


// Mutation
export const useCreateBannerMutation = () => useMutation({ mutationFn: createBanner });
export const useUpdateBannerMutation = () => useMutation({ mutationFn: updateBanner });
export const useDeleteBannerMutation = () => useMutation({ mutationFn: deleteBanner });
export const useDeleteMutilShortlinkMutation = () => useMutation({ mutationFn: deleteMutilShortlink });
export const useUpdateThumbnailMutation = () => useMutation({ mutationFn: updateThumbnail });
export const useUploadBannerMutation = () => useMutation({ mutationFn: uploadBanner });
export const useExportTemplateMutation = () => useMutation({ mutationFn: exportTemplate });
export const useSetActiveBannerMutation = () => useMutation({ mutationFn: setActiveBanner });

// Query
export const useQueryGetListBanner = (params = {}, options = {}) =>
  useQuery({ queryKey: ['getListBanner', params], queryFn: () => getListBanner(params), ...options });
